/*
 * @version: 1.0
 * @Date: 2021-08-31 16:17:16
 * @LastEditTime: 2021-10-26 10:55:02
 * @FilePath: \accurate_sugar_control\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


import 'lib-flexible'
import { Base64 } from 'js-base64'
Vue.prototype.$Base64 = Base64;

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import axios from 'axios'
Vue.prototype.$axios = axios;
import Qs from 'qs'
import api from '@/api/api.js'
Vue.prototype.$api = api;

import Mint from 'mint-ui';
import 'mint-ui/lib/style.css';
Vue.use(Mint);


import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)


import echarts from 'echarts'
Vue.prototype.$echarts = echarts;

import md5 from 'js-md5'
Vue.prototype.$md5 = md5;

import Print from 'vue-print-nb';

Vue.use(Print);

Vue.config.productionTip = false


//百度地图
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmScale from 'vue-baidu-map/components/controls/Scale'
import BmNavigation from 'vue-baidu-map/components/controls/Navigation'
import BmMarkerClusterer from  'vue-baidu-map/components/extra/MarkerClusterer'
import BmMarker from 'vue-baidu-map/components/overlays/Marker'
import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow'
// 将自动注册所有组件为全局组件(test)
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)
/* eslint-disable no-new */

//使用钩子函数对路由进行权限跳转
// router.beforeEach((to, from, next) => {
//   const role = sessionStorage.getItem('ms_username');
//   if (!role && to.path !== '/login') {
//       next('/login');
//   }else{
//       next();
//   }
// })
new Vue({
  el: '#app',
  router,
  components: {
	  App,
	  BaiduMap,
	  BmInfoWindow,
	  BmMarker,
	  BmMarkerClusterer,
	  BmScale,
	  BmNavigation,
	  BmMarkerClusterer,
    VueQuillEditor
	},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js